<script lang="ts" setup>
import { computed } from "vue"
import { Multiselect as VueMultiselect } from "vue-multiselect"

type FlatOption = { name: string; value: string }
type GroupedOption = { groupLabel: string; groupValues: FlatOption[] }

const props = defineProps<{
    context?: any
}>()

const flatOptions = computed<FlatOption[]>(() => {
    if (props.context.groupedOptions) {
        return (props.context.groupedOptions as GroupedOption[]).flatMap(g => g.groupValues)
    }
    const options = props.context.optionsFiltered || props.context.options || []
    return options.map((option: { label: string; value: string }) => ({
        name: option.label,
        value: option.value,
    }))
})

const options = computed(() => {
    if (props.context.groupedOptions) {
        return props.context.groupedOptions as GroupedOption[]
    }
    return flatOptions.value
})

const model = computed({
    get: () => {
        if (props.context.multiple) {
            const values: string[] = Array.isArray(props.context.value) ? props.context.value : []
            return values.map((id: string) => ({ name: getOptionName(id), value: id }))
        }
        return {
            name: getOptionName(props.context.value),
            value: props.context._value,
        }
    },
    set: value => {
        if (props.context.multiple) {
            props.context.node.input((value as FlatOption[]).map(v => v.value))
        } else {
            props.context.node.input((value as FlatOption).value)
        }
    },
})

function getOptionName(id: string): string | undefined {
    return flatOptions.value.find(option => option.value === id)?.name
}
</script>
<template>
    <VueMultiselect
        v-model="model"
        :options="options"
        :placeholder="context.node.context.label"
        label="name"
        track-by="value"
        :multiple="context.multiple ?? false"
        :group-label="context.groupedOptions ? 'groupLabel' : undefined"
        :group-values="context.groupedOptions ? 'groupValues' : undefined"
        :group-select="context.groupSelect ?? false"
        :close-on-select="context.closeOnSelect ?? true"
    ></VueMultiselect>
</template>
